/* RESPONSIBLE TEAM: team-phone */
import { inject as service } from '@ember/service';
import WorkspaceSettingsRoute from 'embercom/routes/apps/app/settings/base/workspace-settings-route';
import type RouterService from '@ember/routing/router-service';
import { get } from 'embercom/lib/ajax';
import { TwilioStringToPhoneNumberType } from 'embercom/models/settings/calling';

export default class PhoneRegulatoryBundlesNewRoute extends WorkspaceSettingsRoute {
  @service declare appService: any;
  @service declare router: RouterService;
  @service declare intl: any;

  beforeModel() {
    super.beforeModel(...arguments);
  }

  async model() {
    let bundles = await get('/ember/calling_settings/fetch_regulatory_bundles', {
      app_id: this.appService.app.id,
    });

    return {
      regulatoryBundles: bundles.map((bundle: any) => {
        return {
          id: bundle.id,
          friendlyName: bundle.friendly_name,
          sid: bundle.sid,
          countryCode: bundle.country_code,
          phoneNumberType: TwilioStringToPhoneNumberType.get(bundle.number_type),
          status: bundle.status,
        };
      }),
    };
  }
}
